import React, { useContext, Fragment } from 'react';
import Anchor from 'components/base/Anchor/Anchor';

import getEntityUrl from 'url-constructors/getEntityUrl';
import { EntityContext } from 'context/entityContext';

interface IArtistLinks {
  artists: any;
  forBreadcrumb?: boolean;
}

const ArtistLinks: React.FC<IArtistLinks> = (props) => {
  const { artists, forBreadcrumb } = props;
  const ctx = useContext(EntityContext);
  const { topic } = ctx;

  if (!artists) return null;

  return (
    <span>
      {!forBreadcrumb && <>By </>}
      {artists.map(({ artist }: any, idx: any, arr: any) => (
        <Fragment key={artist.id}>
          {artist.id ? (
            <Anchor
              withChevron={!forBreadcrumb}
              to={getEntityUrl({
                entityType: artist.type,
                entityId: artist.id,
                topic: topic.join('/'),
              })}
            >
              {artist.displayName}
            </Anchor>
          ) : (
            artist.displayName
          )}

          {idx < arr.length - 1 && ',  '}
        </Fragment>
      ))}
    </span>
  );
};

export default ArtistLinks;
